/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * The type of the contract
 */
export enum FetchContractResponseType {
  care= 'care',
  full_care= 'full_care',

}